import { useMutation } from '@tanstack/react-query';
import { extractEventDetailsFromPrompt } from '../services/extractEventDetails';

/** POST /admin/extract-event-details */
export const useExtractEventDetailsMutation = (options = {}) => {
  const { onSuccess, onError, ...restOptions } = options;

  return useMutation({
    mutationFn: async (prompt) => {
      const result = await extractEventDetailsFromPrompt(prompt);
      if (!result.success) {
        throw new Error(result.message || 'Failed to extract event details');
      }
      return result;
    },
    onSuccess: async (data, variables, context) => {
      await onSuccess?.(data, variables, context);
    },
    onError: (error, variables, context) => {
      onError?.(error, variables, context);
    },
    ...restOptions,
  });
};
